module.exports = __webpack_public_path__ + "static/media/homebody5.c7cbe5d3.png";